import { useLeadStatuses } from 'entities/lead/lead-status';
import { LeadStatusDto } from '@sr/dto';
import { withRemoteCollectionDropDownPicker } from 'shared/ui/form-fields/with-remote-collection-dropdown';
import { useMemo } from 'react';

type InternalPicker = ReturnType<typeof withRemoteCollectionDropDownPicker<LeadStatusDto, number>>;
type PickerProps = React.ComponentProps<InternalPicker>;

type Props = {
  showOnlyAvailableStatuses?: boolean;
  excludedStatusIds?: number[];
} & PickerProps;

export const LeadStatusPicker = (props: Props) => {
  const { showOnlyAvailableStatuses, excludedStatusIds, ...restProps } = props;

  const useCollectionProvider = () => useLeadStatuses({ showOnlyAvailableStatuses, excludedStatusIds });

  const Picker = useMemo(
    () =>
      withRemoteCollectionDropDownPicker<LeadStatusDto, number>({
        collectionProvider: useCollectionProvider,
        renderDropdownLabel: (item: LeadStatusDto | '') =>
          typeof item === 'string' ? item : item.label,
        renderEmptyValue: <>&nbsp;</>
      }),
    [useCollectionProvider]
  );

  return <Picker {...restProps} />;
};
